import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeId } from '../utils/functions';

export const useQueryParamsWithIds = () => {
  const location = useLocation();
  const query = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const clientId = useMemo(() => {
    const base64ClientId = query.get('clientId') ?? '';
    return decodeId(base64ClientId ?? '');
  }, [query]);

  const advisorId = useMemo(() => {
    const base64ClientId = query.get('advisorId') ?? '';
    return decodeId(base64ClientId ?? '');
  }, [query]);

  return { query, clientId, advisorId };
};
